var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaddingSidesMd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_165)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 20H152V78H44V20Z",
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 20V22.0714H44.5V20H43.5ZM43.5 26.2143V30.3571H44.5V26.2143H43.5ZM43.5 34.5V38.6429H44.5V34.5H43.5ZM43.5 42.7857V46.9286H44.5V42.7857H43.5ZM43.5 51.0714V55.2143H44.5V51.0714H43.5ZM43.5 59.3571V63.5H44.5V59.3571H43.5ZM43.5 67.6429V71.7857H44.5V67.6429H43.5ZM43.5 75.9286V78H44.5V75.9286H43.5ZM152.5 78V75.9286H151.5V78H152.5ZM152.5 71.7857V67.6429H151.5V71.7857H152.5ZM152.5 63.5V59.3571H151.5V63.5H152.5ZM152.5 55.2143V51.0714H151.5V55.2143H152.5ZM152.5 46.9286V42.7857H151.5V46.9286H152.5ZM152.5 38.6429V34.5H151.5V38.6429H152.5ZM152.5 30.3571V26.2143H151.5V30.3571H152.5ZM152.5 22.0714V20H151.5V22.0714H152.5Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 86,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 86,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -46,
    width: 180,
    height: 58,
    rx: 5,
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: -46,
    width: 180,
    height: 58,
    rx: 5,
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6464 48.6464C15.4512 48.8417 15.4512 49.1583 15.6464 49.3536L18.8284 52.5355C19.0237 52.7308 19.3403 52.7308 19.5355 52.5355C19.7308 52.3403 19.7308 52.0237 19.5355 51.8284L16.7071 49L19.5355 46.1716C19.7308 45.9763 19.7308 45.6597 19.5355 45.4645C19.3403 45.2692 19.0237 45.2692 18.8284 45.4645L15.6464 48.6464ZM36.3536 49.3536C36.5488 49.1583 36.5488 48.8417 36.3536 48.6464L33.1716 45.4645C32.9763 45.2692 32.6597 45.2692 32.4645 45.4645C32.2692 45.6597 32.2692 45.9763 32.4645 46.1716L35.2929 49L32.4645 51.8284C32.2692 52.0237 32.2692 52.3403 32.4645 52.5355C32.6597 52.7308 32.9763 52.7308 33.1716 52.5355L36.3536 49.3536ZM16 49.5H36V48.5H16V49.5Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.646 48.6464C159.451 48.8417 159.451 49.1583 159.646 49.3536L162.828 52.5355C163.024 52.7308 163.34 52.7308 163.536 52.5355C163.731 52.3403 163.731 52.0237 163.536 51.8284L160.707 49L163.536 46.1716C163.731 45.9763 163.731 45.6597 163.536 45.4645C163.34 45.2692 163.024 45.2692 162.828 45.4645L159.646 48.6464ZM180.354 49.3536C180.549 49.1583 180.549 48.8417 180.354 48.6464L177.172 45.4645C176.976 45.2692 176.66 45.2692 176.464 45.4645C176.269 45.6597 176.269 45.9763 176.464 46.1716L179.293 49L176.464 51.8284C176.269 52.0237 176.269 52.3403 176.464 52.5355C176.66 52.7308 176.976 52.7308 177.172 52.5355L180.354 49.3536ZM160 49.5H180V48.5H160V49.5Z",
    fill: "#007FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddingSidesMd);
export default __webpack_public_path__ + "static/media/padding_sides_md.7cd5d73bd85177f96cf2cfe0eee889b0.svg";
export { ForwardRef as ReactComponent };